import * as React from "react";
import {
  Typography,
  Box,
  Container,
  TextField,
  Button,
  Avatar,
  CircularProgress,
  Chip,
  FormControlLabel,
  Checkbox,
  Tooltip,
  Paper,
  Stack,
  Divider,
  MenuItem,
} from "@mui/material";
import { connect } from "react-redux";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import UploadIcon from "@mui/icons-material/Upload";
import {
  centered_flex_box,
  MainInput,
  MainTextArea,
  main_button,
} from "../../app/components/Styles";
import { useNavigate } from "react-router-dom";
import ReactFileReader from "react-file-reader";
import { uploadFile } from "../../core/aws";
import { config } from "../../app/config";
import { createWhatsappCampaign, getWhatsappTemplates } from "../../app/store/actions/adminActions";

export const CreateCampaign = ({ isLoading, templates, getWhatsappTemplates, createWhatsappCampaign }) => {
  const navigate = useNavigate();
  const [image, setImage] = React.useState(null);
  const [allowPlusOne, setAllowPlusOne] = React.useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = React.useState("");

  React.useEffect(() => {
    getWhatsappTemplates && getWhatsappTemplates({ page: 1, limit: 100, search: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddImage = (files) => {
    let file = files[0];
    console.log(file);
    setImage(file);
  };

  const handleDeleteImage = () => {
    setImage(null);
  };

  const handleTemplateChange = (value) => {
    setSelectedTemplateId(value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    
    try {
      var imageUrl;
      
      if (image) {
        imageUrl = await uploadFile(image);
      }

      if (!selectedTemplateId) {
        return console.error("Please select a template");
      }

      const creation = {
        title: data.get("title"),
        description: data.get("description"),
        template: selectedTemplateId,
        allowPlusOne: allowPlusOne,
        image: imageUrl,
      };

      createWhatsappCampaign(creation, navigate);
    } catch (err) {
      console.log(err);
    }
  };

  if (isLoading) {
    return (
      <Box sx={{ ...centered_flex_box, minHeight: "100vh" }}>
        <CircularProgress sx={{ color: "var(--secColor)" }} />
      </Box>
    );
  }

  return (
    <Container component="main" maxWidth="md">
      <Box sx={{ py: { xs: 3, md: 6 }, mb: { xs: 4, md: 12 }, px: { xs: 2, md: 3 } }}>
        <Box sx={{ ...centered_flex_box, flexDirection: "column", mb: 3 }}>
          <Avatar sx={{ bgcolor: "var(--secColor)" }}>
            <AddCircleOutlineIcon />
          </Avatar>
          <Typography component="h1" variant="h5" fontWeight="bold" sx={{ mt: 1, color: "var(--primaryPurple)" }}>
            Create WhatsApp Campaign
          </Typography>
        </Box>
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 3, md: 4 }, borderRadius: 3 }}>
          <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
            <Stack spacing={2}>
              <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ xs: "stretch", sm: "center" }}>
                <ReactFileReader
                  multipleFiles={false}
                  handleFiles={handleAddImage}
                  fileTypes={[".jpeg", ".jpg", ".png", ".svg"]}
                >
                  <Button sx={{ ...main_button }} fullWidth={true}>
                    <UploadIcon /> Upload Campaign Image
                  </Button>
                </ReactFileReader>
                {image && (
                  <Chip
                    label={image.name}
                    onDelete={handleDeleteImage}
                    sx={{ color: "var(--primaryPurple)", bgcolor: "var(--secColor)" }}
                  />
                )}
              </Stack>

              <MainInput required fullWidth id="title" label="Campaign Title" name="title" />

              <MainTextArea
                required
                fullWidth
                multiline
                minRows={4}
                name="description"
                label="Campaign Description"
                id="description"
              />

              <Divider textAlign="left">
                <Typography variant="subtitle2" sx={{ color: "var(--primaryPurple)", fontWeight: 700 }}>
                  WhatsApp Template
                </Typography>
              </Divider>

              <MainInput
                select
                fullWidth
                id="template"
                label="Select WhatsApp Template"
                name="template"
                value={selectedTemplateId}
                onChange={(e) => handleTemplateChange(e.target.value)}
                SelectProps={{
                  MenuProps: {
                    PaperProps: { sx: { bgcolor: 'var(--platform-surface)', color: 'var(--primaryPurple)' } },
                  },
                }}
              >
                {(templates?.docs || []).map((tpl) => (
                  <MenuItem key={tpl._id} value={tpl._id} sx={{ color: 'var(--primaryPurple)' }}>
                    {tpl.name} — {tpl.language} — {tpl.status}
                  </MenuItem>
                ))}
              </MainInput>

              <Tooltip title="Allow recipients to bring a plus one">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={allowPlusOne}
                      onChange={(e) => setAllowPlusOne(e.target.checked)}
                      name="allowPlusOne"
                      id="allowPlusOne"
                    />
                  }
                  label="Allow Plus One"
                />
              </Tooltip>

              <Button type="submit" fullWidth variant="contained" sx={{ ...main_button, mt: 1 }}>
                Create Campaign
              </Button>
            </Stack>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  token: state?.auth?.token,
  isLoading: state?.events?.isLoading,
  templates: state?.records?.results?.templates,
});

export default connect(mapStateToProps, { getWhatsappTemplates, createWhatsappCampaign })(CreateCampaign);

